import { proxy, subscribe } from "valtio";
import { SiteFiltersStore, SiteFiltersStoreSchema, defaultValues } from "./store";

const LOCAL_STORAGE_KEY = "siteFiltersMapStore";

function loadFiltersFromLocalStorageSafely(): SiteFiltersStore {
  try {
    const persistedFilters = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)!);

    if (!persistedFilters) {
      return { ...defaultValues };
    }

    return SiteFiltersStoreSchema.parse(persistedFilters);
  } catch (error) {
    console.error("Error loading persisted filters:", error);
    return { ...defaultValues };
  }
}

export const siteFiltersMapStore = proxy<SiteFiltersStore>(loadFiltersFromLocalStorageSafely());

// when the store changes, persist the filters to local storage
subscribe(siteFiltersMapStore, function syncStoreToLocalStorage() {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(siteFiltersMapStore));
});
